<template>
  <b-container fluid class="mr-0 pr-0 sidebar">
    <b-row :class="`${customer}`" no-gutters>
      <b-col
        cols="12"
        class="mb-4"
        v-for="(sidebar, index) in sidebarData"
        :key="index"
      >
        <div>
          <div
            v-if="!['cuadrado'].includes(template)"
            class="content-head text-content-header mb-0"
          >
            <b class="h4"
              ><b class="small">{{ sidebar.categoria }}</b></b
            >
            <div class="mt-2">
              {{ sidebar.elementoSidebars[0].titulo }}
            </div>
          </div>
          <b-carousel
            v-if="sidebar.elementoSidebars.length > 1"
            controls
            class="sidebar-slide mb-0"
            :interval="0"
          >
            <b-carousel-slide
              v-for="(notice, k) in sidebar.elementoSidebars"
              :key="k"
              img-blank
            >
              <div class="content-image">
                <a
                  v-if="notice.link && notice.linkEnImagen"
                  :href="notice.link"
                  target="_blank"
                >
                  <img
                    :src="notice.url"
                    class="img-fluid d-block"
                    alt="imagen noticia"
                  />
                </a>
                <img
                  v-else
                  :src="notice.url"
                  class="img-fluid d-block"
                  alt="imagen noticia"
                />
                <div
                  v-if="['cuadrado'].includes(template)"
                  class="content-text"
                >
                  <div class="title">
                    {{ notice.titulo }}
                  </div>
                  <a v-if="notice.link" :href="notice.link" target="_blank">
                    Ver más
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20px"
                      height="20px"
                      viewBox="0 0 384 512"
                    >
                      <path
                        d="M336 96c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-185.4L59.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128 112 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0z"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <template v-if="!['cuadrado'].includes(template)">
                <div
                  v-if="notice.texto"
                  class="content-head content-body text-content-header text-left"
                >
                  <b class="h4">{{ sidebar.titulo }}</b>
                  <div
                    v-if="notice.texto"
                    v-html="notice.texto"
                    class="text-justify"
                  ></div>
                </div>
                <a
                  v-if="notice.link && !notice.linkEnImagen"
                  :href="notice.link"
                  target="_blank"
                  class="btn-sidebar text-right w-100 d-block p-2 text-bold"
                >
                  Ver más >
                </a>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <div v-else controls class="sidebar-slide mb-0">
            <div class="content-image">
              <a
                v-if="
                  sidebar.elementoSidebars[0].link &&
                  sidebar.elementoSidebars[0].linkEnImagen
                "
                :href="sidebar.elementoSidebars[0].link"
                target="_blank"
              >
                <img
                  :src="sidebar.elementoSidebars[0].url"
                  class="img-fluid d-block"
                  alt="imagen noticia"
                />
              </a>
              <img
                v-else
                :src="sidebar.elementoSidebars[0].url"
                class="img-fluid d-block"
                alt="imagen noticia"
              />
              <div v-if="['cuadrado'].includes(template)" class="content-text">
                <div class="title">
                  {{ sidebar.elementoSidebars[0].titulo }}
                </div>
                <a
                  v-if="sidebar.elementoSidebars[0].link"
                  :href="sidebar.elementoSidebars[0].link"
                  target="_blank"
                >
                  Ver más
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20px"
                    height="20px"
                    viewBox="0 0 384 512"
                  >
                    <path
                      d="M336 96c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-185.4L59.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128 112 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0z"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <template v-if="!['cuadrado'].includes(template)">
              <div
                v-if="sidebar.elementoSidebars[0].texto"
                class="content-head content-body text-content-header text-left"
              >
                <div
                  v-if="sidebar.elementoSidebars[0].texto"
                  v-html="sidebar.elementoSidebars[0].texto"
                  class="text-justify"
                ></div>
              </div>
              <a
                v-if="sidebar.elementoSidebars[0].link"
                :href="sidebar.elementoSidebars[0].link"
                target="_blank"
                class="btn-sidebar text-right w-100 d-block p-2 text-bold"
              >
                Ver más >
              </a>
            </template>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "sidebar",
  components: {},
  props: {
    sidebarData: { default: [] },
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.substring(0, length) + suffix;
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    template() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.template
        : "default";
    },
  },
};
</script>
<style>
.height-6em {
  height: 6em;
}
.padding-1em-sides {
  padding: 0 1em;
}
.card-notice {
  background: #54504f !important;
  border-radius: 5px 5px;
}
.content-image img {
  width: 100% !important;
}
.content-head,
article,
.footer-card {
  padding: 0.5em 1em;
}
.show-more {
  text-align: right;
  background: #b22322;
  padding: 0.1em;
}
</style>
